import Vue from 'vue'
import Vuex from 'vuex'
import localSt from './modules/localStorage'
import AxiosControl from './modules/AxiosControl'
// 用户相关
import user from './modules/user'
import cache from './modules/cache'
import permission from './modules/permission'
import { userAgentType } from '../utils/utils'
import getDeviceInfo from '@/utils/userAgent' // 统计操作日志
import {
  logUserAction // 用户操作日志 记录收集
} from '@/api/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production', // 非生产环境使用严格模式
  state: {
    // 缩放比例
    per: Math.min((window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) / 750, 1),
    // 终端类型
    clientType: {
      10101: '单体',
      10201: '连锁门店',
      10202: '连锁总部',
      20100: '诊所'
    },
    // 手机系统类型：android，ios 或者 ''
    UserAgent: userAgentType()
  },
  // 计算属性
  getters: {
    // 终端类型列表
    clientTypeList (state) {
      const { entries } = Object
      const list = []
      for (const [key, value] of entries(state.clientType)) {
        list.push({
          code: key,
          name: value
        })
      }
      return list
    },
    provinceList () {
      return user.state.ProvinceInfo
    },
    permissionsInfo () {
      return user.state.PermissionsInfo
    },
    userInfo () {
      return user.state.UserInfo
    }
  },
  mutations: {
    // 处理vuex中的终端客户类型的问题
    clientTypesChange: (state, value) => {
      state.clientType = value
    }
  },
  actions: {
    // 百度统计事件分析上报
    // eslint-disable-next-line no-unused-vars
    PushHmtTrackEvent ({ commit, state }, obj) {
      /* category：要监控的目标的类型名称，通常是同一组目标的名字，比如”视频”、”音乐”、”软件”、”游戏”等等。该项必选。
               action：用户跟目标交互的行为，如”播放”、”暂停”、”下载”等等。该项必选。
               optLabel：事件的一些额外信息，通常可以是歌曲的名称、软件的名称、链接的名称等等。该项可选。
               optValue：事件的一些数值信息，比如权重、时长、价格等等，在报表中可以看到其平均值等数据。该项可选。
            */
      if (window.location.href.indexOf('mlbs.yiyao.cc') !== -1) {
        try {
          window._hmt.push(['_trackEvent', obj.category, obj.action || '点击', obj.optLabel || '', obj.optValue || ''])
        } catch (err) {
          console.log(err)
        }
      }
    },
    /**
         * 用户操作日志 记录收集上报
         * @params params:{ menu:"菜单/栏目", page:"页面标题", operation:"操作动作" }
         */
    // eslint-disable-next-line no-unused-vars
    PushUserLog ({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        const deviceInfo = getDeviceInfo()
        params.menu = '手机端'
        params.device = deviceInfo.channel
        params.os = deviceInfo.system
        params.browser = deviceInfo.browser
        logUserAction(params).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  modules: {
    cache,
    user,
    localSt,
    AxiosControl,
    permission
  }
})
